import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { DELIVERY, propTypes } from '../../util/types';

import css from './BookingBreakdown.css';

const LineItemDeliveryTypeMaybe = ({ transaction }) => {
  const { delivery, deliveryAddress } = transaction &&
    transaction.attributes &&
    transaction.attributes.protectedData &&
    transaction.attributes.protectedData.deliveryData
    ? transaction.attributes.protectedData.deliveryData
    : {}

  const type = delivery === DELIVERY ? "Delivery" : "Pickup"
  const address = deliveryAddress && deliveryAddress.address;

  const classOfDeliveryAddressTitle = classNames(css.itemLabel, css.deliveryAddressTitle);
  const classOfDeliveryAddressValue = classNames(css.itemValue, css.deliveryAddressValue);

  return (
    <>
      <div className={css.lineItem}>
        <span className={css.itemLabel}>
          <FormattedMessage id={'LineItemDelivery.deliveryType'} />
        </span>
        <span className={css.itemValue}>{type}</span>
      </div>

      {delivery === DELIVERY && deliveryAddress !== "" &&
        <div className={css.lineItem}>
          <span className={classOfDeliveryAddressTitle}>
            <FormattedMessage id={'LineItemDelivery.deliveryAddress'} />
          </span>
          <span className={classOfDeliveryAddressValue}>{address}</span>
        </div>
      }

      <hr className={css.totalDivider} />
    </>
  );
};

LineItemDeliveryTypeMaybe.propTypes = {
  transaction: propTypes.transaction.isRequired,
};

export default LineItemDeliveryTypeMaybe;
